import { useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import useBeforeNavigate from '../../hooks/useBeforeNavigate';
import { LockOrderContext } from '../../context/LockOrderContext';
import { SafeKeyButton } from '../buttons/SafeKeyButton';
import { Typography } from '@mui/material';

const NavigationWarningAlert = () => {
  const beforeNavigate = useBeforeNavigate();
  const { showNavigationWarning } = useContext(LockOrderContext);
  return (
    <Dialog
      open={showNavigationWarning}
      onClose={beforeNavigate.close}
    >
      <DialogTitle>Unsaved Changes</DialogTitle>
      <DialogContent>
        <Typography variant='body1'>
          You have unsaved changes that will be lost if you continue before
          saving!
        </Typography>
        <br />
        <Typography variant='body1'>
          Continue and discard your unsaved changes?
        </Typography>
      </DialogContent>
      <DialogActions>
        <SafeKeyButton
          onClick={() => {
            beforeNavigate.act();
          }}
        >
          Discard Changes
        </SafeKeyButton>
        <SafeKeyButton onClick={beforeNavigate.close}>Cancel</SafeKeyButton>
      </DialogActions>
    </Dialog>
  );
};

export default NavigationWarningAlert;
